module.exports = __webpack_public_path__ + "img/bm6.63046c4f.png";